import { links } from "@/data/links";
import { Lang } from "@/i18n-config";

export const startNewChat = ({ lang }: { lang: Lang }) => {
  window.history.pushState({}, "", `/${lang}/${links.myWinwingpt}`);
  window.location.reload();
};
